import React from 'react';
import { motion } from 'framer-motion';
export function Features() {
  return <section id="features" className="py-24 border-b border-stone-300" data-id="element-917">
      <div className="max-w-6xl mx-auto px-6" data-id="element-918">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-919">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-920">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-921">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-922">
                Platform
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-900 mb-6" data-id="element-923">
                Everything you need to quote, hold, and close
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-924">
                A complete operating system for group travel distribution. Built
                for revenue teams who need control.
              </p>
            </div>

            {/* Right: Feature list */}
            <div className="lg:col-span-8" data-id="element-925">
              <div className="border-t border-stone-300" data-id="element-926">
                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-927">
                  <div className="col-span-1" data-id="element-928">
                    <span className="font-mono text-xs text-stone-400" data-id="element-929">01</span>
                  </div>
                  <div className="col-span-4" data-id="element-930">
                    <p className="font-medium text-stone-900" data-id="element-931">
                      Multi-Property Quotes
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-932">
                    <p className="text-stone-600" data-id="element-933">
                      Instant quotes across your entire portfolio. Room blocks,
                      dates, occupancy, event needs—handled in seconds.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-934">
                  <div className="col-span-1" data-id="element-935">
                    <span className="font-mono text-xs text-stone-400" data-id="element-936">02</span>
                  </div>
                  <div className="col-span-4" data-id="element-937">
                    <p className="font-medium text-stone-900" data-id="element-938">Smart Holds</p>
                  </div>
                  <div className="col-span-7" data-id="element-939">
                    <p className="text-stone-600" data-id="element-940">
                      Automated hold timers with expiry management. Inventory
                      secured, no manual follow-ups required.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-941">
                  <div className="col-span-1" data-id="element-942">
                    <span className="font-mono text-xs text-stone-400" data-id="element-943">03</span>
                  </div>
                  <div className="col-span-4" data-id="element-944">
                    <p className="font-medium text-stone-900" data-id="element-945">
                      Package Builder
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-946">
                    <p className="text-stone-600" data-id="element-947">
                      Good / Better / Best options auto-generated within your
                      pricing policy. Maximize conversion, protect margins.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-948">
                  <div className="col-span-1" data-id="element-949">
                    <span className="font-mono text-xs text-stone-400" data-id="element-950">04</span>
                  </div>
                  <div className="col-span-4" data-id="element-951">
                    <p className="font-medium text-stone-900" data-id="element-952">
                      Proposal Generation
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-953">
                    <p className="text-stone-600" data-id="element-954">
                      Standardized, branded proposals exported in one click.
                      Ready for client presentation.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-955">
                  <div className="col-span-1" data-id="element-956">
                    <span className="font-mono text-xs text-stone-400" data-id="element-957">05</span>
                  </div>
                  <div className="col-span-4" data-id="element-958">
                    <p className="font-medium text-stone-900" data-id="element-959">Policy Engine</p>
                  </div>
                  <div className="col-span-7" data-id="element-960">
                    <p className="text-stone-600" data-id="element-961">
                      Rate floors, blackout dates, concession limits—enforced
                      automatically across all quotes.
                    </p>
                  </div>
                </div>

                <div className="py-6 grid grid-cols-12 gap-4" data-id="element-962">
                  <div className="col-span-1" data-id="element-963">
                    <span className="font-mono text-xs text-stone-400" data-id="element-964">06</span>
                  </div>
                  <div className="col-span-4" data-id="element-965">
                    <p className="font-medium text-stone-900" data-id="element-966">Audit Trail</p>
                  </div>
                  <div className="col-span-7" data-id="element-967">
                    <p className="text-stone-600" data-id="element-968">
                      Every quote, change, and approval tracked and reportable.
                      Complete visibility for revenue teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}